import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { ChatWindow } from './ChatWindow';
export function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <button onClick={() => setIsOpen(!isOpen)} className="fixed bottom-4 right-4 w-14 h-14 bg-primary hover:bg-primary-dark text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 z-50 group" aria-label="Open Chat" data-id="element-49">
        <MessageSquare className="w-7 h-7 group-hover:animate-pulse" data-id="element-50" />
      </button>

      <ChatWindow isOpen={isOpen} onClose={() => setIsOpen(false)} data-id="element-51" />
    </>;
}